import { create } from 'zustand';

export type IFilterFields = {
  vehicle_brand_id: string;
  vehicle_model_id: string;
  vehicle_type_id: string;
  vehicle_subtype_id: string;
  carrier_id: string;
  vehicle_plate: string;
  renavam: string;
  webcol_id: string | undefined;
};

type FiltersState = {
  filtersData: IFilterFields;
  setFiltersData: (filters: IFilterFields) => void;
  clearFilters: () => void;
};

const initalFilters: IFilterFields = {
  vehicle_type_id: '',
  vehicle_subtype_id: '',
  carrier_id: '',
  vehicle_brand_id: '',
  vehicle_model_id: '',
  vehicle_plate: '',
  renavam: '',
  webcol_id: process.env.REACT_APP_HUB_WEBCOL_ID,
};

export const useFilterStore = create<FiltersState>((set) => ({
  filtersData: initalFilters,
  setFiltersData: (filters) => set({ filtersData: filters }),
  clearFilters: () => set({ filtersData: initalFilters }),
}));
